import React, {useEffect, useReducer} from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import {useSelector} from 'react-redux';
import {Col, Row} from 'react-grid-system';
import axios from 'axios';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {addAlertToDOM} from '../../../../helpers/util';

const buildInitialFormValues = (data) => {
  const {
    email = '',
    status = false,
    first_name: firstName = '',
    last_name: lastName = '',
    roles = [],
    groups = [],
  } = data ?? {};

  return {
    email,
    status,
    firstName,
    lastName,
    role: roles.length > 0 ? roles[0].id : '',
    group: groups.length > 0
      ? groups.map((g) => ({ value: g.id, label: g.label }))
      : [],
  };
};


const EditUserLayout = ({data, onSubmit, onCancel}) => {
  const {roles, groups, modalTimeout} = useSelector(state => state.util);

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: buildInitialFormValues(data)
  });

  useEffect(() => {
    if (data) {
      reset(buildInitialFormValues(data));
    }
  }, [data, reset]);


  const onSubmitForm = async (formData) => {
    const requestPayload = {
      login_id: formData.email,
      email: formData.email,
      first_name: formData.firstName,
      last_name: formData.lastName,
      roles: formData.role === '' ? [] : [formData.role],
      add_on_details: {
        groups: formData.group.map(g => g.value),
        status: formData.status,
        full_name: `${formData.firstName} ${formData.lastName}`,
      }
    };

    try {
      const response = await axios.put('/api/v1/user/edit', requestPayload);
      if (response.status === 200) {
        addAlertToDOM('.deul-section', 'success', 'User data updated successfully', 'mb-15');
        onSubmit && setTimeout(() => onSubmit(), modalTimeout);
      } else {
        addAlertToDOM('.deul-section', 'warning', 'Something went wrong. Try again.', 'mb-15');
      }
    } catch (error) {
      addAlertToDOM('.deul-section', 'warning', 'Something went wrong. Try again.', 'mb-15');
    }
  };

  const handleCancel = (e) => {
	e.preventDefault();
	onCancel && onCancel(e);
	reset(buildInitialFormValues(data));
  };

  return (
	<>
		<div className="deul-section" />
		<form onSubmit={handleSubmit(onSubmitForm)}>
		<Row>
			{/* Email */}
			<Col xs={6} className="mb-20">
			<label htmlFor="email">Email :</label>
			<input
				{...register("email")}
				id="email"
				type="email"
				className="um-input full-width"
				placeholder="Ex: john007@gmail.com"
				readOnly
			/>
			</Col>

			{/* Status Checkbox */}
			<Col xs={6} className="mb-20">
			<label htmlFor="status">Status :</label>
			<div className="checkbox-wrapper">
				<Controller
				name="status"
				control={control}
				render={({ field }) => (
					<>
					<input
						id="status"
						type="checkbox"
						checked={field.value}
						onChange={e => field.onChange(e.target.checked)}
					/>
					<label className="cursor-pointer" htmlFor="status">Enable</label>
					</>
				)}
				/>
			</div>
			</Col>

			{/* First Name */}
			<Col xs={6} className="mb-20">
			<label htmlFor="firstName">First Name :</label>
			<input
				{...register("firstName")}
				id="firstName"
				type="text"
				className="um-input full-width"
				placeholder="Ex: John"
			/>
			</Col>

			{/* Last Name */}
			<Col xs={6} className="mb-20">
			<label htmlFor="lastName">Last Name :</label>
			<input
				{...register("lastName")}
				id="lastName"
				type="text"
				className="um-input full-width"
				placeholder="Ex: Doe"
			/>
			</Col>

			{/* Role Select */}
			<Col xs={6} className="mb-20">
			<label htmlFor="role">Role :</label>
			<select
				{...register("role")}
				className="um-select full-width"
				required
			>
				<option value="" disabled hidden>Select Role</option>
				{roles.map(({ _id, name }) => (
				<option value={_id} key={_id}>{name}</option>
				))}
			</select>
			</Col>

			{/* Group Select (react-select) */}
			<Col xs={6} className="mb-20">
			<label htmlFor="group">Dealers</label>
			<Controller
				name="group"
				control={control}
				render={({ field }) => (
				<Select
					{...field}
					options={groups.map(item => ({
					value: item.id,
					label: item.label
					}))}
					isMulti
					placeholder="Select Dealers"
					menuShouldBlockScroll={true}
					menuPortalTarget={document.body}
					menuPosition="absolute"
					styles={{
						menuPortal: base => ({
							...base,
							zIndex: 9999, // tampil di atas modal
						}),
						menuList: base => ({
							...base,
							maxHeight: '150px',
							overflowY: 'auto',
						}),
						valueContainer: base => ({
							...base,
							maxHeight: "120px",
							overflowY: "auto",
						}),
					}}
				/>
				)}
			/>
			</Col>

			{/* Submit + Cancel */}
			<Col xs={12} className="text-right">
			<button
				type="submit"
				className="um-button um-button--primary mr-10"
				disabled={isSubmitting}
			>
				{isSubmitting ? (
				<span>
					<FontAwesomeIcon
					className="loading-icon mr-5"
					icon={faSpinner}
					spin
					/>
					Submit
				</span>
				) : 'Submit'}
			</button>

			<button
				type="button"
				className="um-button um-button--reset"
				onClick={handleCancel}
			>
				Cancel
			</button>
			</Col>
		</Row>
		</form>
	</>
	);

};

export default EditUserLayout;
